import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface DemoAccount {
  key: 'VERWALTUNG' | 'MIETER' | 'HANDWERKER';
  label: string;
  email: string;
  password: string;
}

export interface DemoInfo {
  enabled: boolean;
  email: string | null;
  password: string | null;
  /** Zugänge für Verwaltung, Mieter- und Handwerkerportal (nur Demo) */
  accounts?: DemoAccount[];
}

/** Öffentliche Demo-Instanz? (Server liefert die Angabe über /api/health) */
export function useDemoInfo(): DemoInfo | null {
  const q = useQuery({
    queryKey: ['health', 'demo'],
    queryFn: async () => (await api.get<{ demo?: DemoInfo }>('/health')).demo ?? null,
    staleTime: Infinity,
    retry: false,
  });
  return q.data ?? null;
}
